import { createStorageManager } from "app/pages/sales-intelligence/services/storage-manager/factory";

const sessionStorageManager = createStorageManager(window.sessionStorage, (key) => `si:leads-search:${key}`);

export const leadsSearchSessionStorage = sessionStorageManager.configList({
    adIntelligenceColumnHookSubmitted: { key: "ad-intelligence-column-hook-submitted", defaultValue: false },
    adSpendVolumeFilterHookSubmitted: { key: "ad-spend-volume-filter-hook-submitted", defaultValue: false },
    adSpendChannelsFilterHookSubmitted: { key: "ad-spend-channels-filter-hook-submitted", defaultValue: false },
    conversionRateFilterHookSubmitted: { key: "conversion-rate-filter-hook-submitted", defaultValue: false },
    conversionRateColumnHookSubmitted: { key: "conversion-rate-column-hook-submitted", defaultValue: false },
    displayAdsFormatFilterHookSubmitted: { key: "display-ads-format-filter-hook-submitted", defaultValue: false },
});
